var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.serverError)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.serverError))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }